import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { CustomerDataQualityProvider } from '@components/UserGroupDataQuality/CustomerDataQualityProvider';
import { UserGroupDataQualityPromptCustomer } from '@components/UserGroupDataQuality/UserGroupDataQualityPromptCustomer';
import type { UserSessionData } from 'noddi-web';
import { BookingCalendarCard } from '../components/BookingCalendarCard';
import { HomePageHeader } from '../components/HomePageHeader';
import { PendingBookingProposals } from '../components/PendingBookingProposals';
import { QuickActions } from '../components/QuickActions';
import { UpcomingBookingsOverview } from '../components/UpcomingBookingsOverview';

type Props = {
  userGroupId: number;
  userData: UserSessionData;
};

export const OrganizationHomePage = ({ userGroupId, userData }: Props) => {
  return (
    <ContentWrapperCustomerApp hideBackButton width='lg'>
      <div className='flex flex-col gap-6 md:gap-10'>
        <HomePageHeader userData={userData} isFirstTimeCustomer={false} />
        {/* includeMembers asks for the other members' personal details; the gate drops it unless this session administers the group. */}
        <CustomerDataQualityProvider userGroupId={userGroupId} includeMembers>
          <UserGroupDataQualityPromptCustomer />
        </CustomerDataQualityProvider>
        <QuickActions />
        <PendingBookingProposals userGroupId={userGroupId} />
        <UpcomingBookingsOverview />
        <BookingCalendarCard />
      </div>
    </ContentWrapperCustomerApp>
  );
};
